import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { uiActions } from 'state/modules/UI';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const SnackbarComponent = () => {
  const dispatch = useDispatch();
  const [state] = useState({
    vertical: 'top',
    horizontal: 'right',
  });

  const { vertical, horizontal } = state;

  const { snackbarType, snackbarOpen, snackbarMessage, autoHideDuration } = useSelector(
    (state) => state.ui
  );

  const handleClose = () => {
    dispatch(uiActions.handleClearSnackbar());
  };

  return (
    <Snackbar
      open={snackbarOpen}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical, horizontal }}
      key={`${state.vertical},${state.horizontal}`}
    >
      <Alert onClose={handleClose} severity={snackbarType}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
